import styled from 'styled-components';

export const DropdownSelectTriggerLabel = styled.span<{ align: 'left' | 'right' }>`
    ${({ align }) => (align === 'left' ? 'margin: 0 6px 0 0' : 'margin: 0 24px 0 auto')};
    color: inherit;

    &[data-placeholder='true'] {
        color: ${({ theme }) => theme.bento.colors.text.weak};
    }
`;
